import type { PlaybookCriterionNode } from "@repo/app-types/entities/playbook";
import type { FC } from "react";
import { Dialog, Heading } from "react-aria-components";
import { CriterionAverageScore } from "../teammatePerformance/criterionAverageScore.js";
import type {
  ChapterWithCriterionScore,
  CriterionInsights,
} from "./trainingInsightsHelpers.js";

export interface CriterionAverageScoreDialogProps {
  criterion: PlaybookCriterionNode;
  insights: CriterionInsights;
}

export const CriterionAverageScoreDialog: FC<
  CriterionAverageScoreDialogProps
> = (props) => {
  const { criterion, insights } = props;

  const renderChapterLabel = (chapter: ChapterWithCriterionScore) => (
    <>
      Chapter {chapter.index + 1}
      {chapter.topic ? (
        <>
          {". "}
          {chapter.topic}
        </>
      ) : null}
    </>
  );

  return (
    <Dialog className="max-w-md space-y-4 px-4 py-3 text-sm">
      <Heading slot="title" className="truncate text-base font-semibold">
        {criterion.name}
      </Heading>

      <div className="grid grid-cols-[1fr_auto] gap-4">
        <div className="col-span-full grid grid-cols-subgrid items-center gap-y-0.5">
          <div className="col-span-full font-semibold whitespace-nowrap">
            Last covered in:
          </div>

          <div className="truncate">
            {renderChapterLabel(insights.lastChapter)}
          </div>

          <CriterionAverageScore
            valueType={criterion.grading_value_type}
            value={insights.lastChapter.value}
          />
        </div>
      </div>

      <div className="text-sm text-gray-600">
        Average score in the last chapter to cover this topic.
      </div>
    </Dialog>
  );
};
